import { create } from 'zustand';
import { Session } from 'next-auth';

type SessionState = {
  session: Session | null;
  sessionLoading: boolean;
  setSession: (session: Session | null) => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  session: null,
  sessionLoading: true,
  setSession: (session) => set({ session, sessionLoading: false }),
}));
